import Vue from 'vue'
import mutations from './mutations'
import clientsDevices from '@/api/clientsDevices'
import { arrayToObject } from '@/utils/object'
import { notify } from '@/utils/error'

export default {
  namespaced: true,

  state: {
    items: {}
  },

  actions: {
    loadItems ({ commit }, { childCompanyId, businessUnitId }) {
      return new Promise((resolve, reject) => {
        clientsDevices.getAll({ childCompanyId, businessUnitId })
          .then(response => {
            const items = arrayToObject(response.data.items)
            commit('setElements', { type: 'items', elements: items })
            resolve(items)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    loadItem ({ commit }, { childCompanyId, businessUnitId, deviceId }) {
      return new Promise((resolve, reject) => {
        clientsDevices.getById({ childCompanyId, businessUnitId, deviceId })
          .then(response => {
            const item = response.data.items[0]
            commit('setElement', { type: 'items', deviceId, element: item })
            resolve(item)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    saveItem ({ commit }, { childCompanyId, businessUnitId, item }) {
      return new Promise((resolve, reject) => {
        clientsDevices.save({ childCompanyId, businessUnitId, item })
          .then(response => {
            const itemId = response.data.items[0].id
            commit('setElement', { type: 'items', id: itemId, element: { id: itemId, ...item } })
            resolve(item)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    deleteItem ({ commit, state }, { childCompanyId, businessUnitId, deviceId }) {
      return new Promise((resolve, reject) => {
        clientsDevices.delete({ childCompanyId, businessUnitId, deviceId })
          .then(response => {
            commit('removeElement', { type: 'items', id: deviceId })
            resolve()
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    deregister ({ commit }, { childCompanyId, businessUnitId, deviceId }) {
      return new Promise((resolve, reject) => {
        clientsDevices.deregister({ childCompanyId, businessUnitId, electronicDeviceId: deviceId })
          .then(response => {
            commit('deregisterDevice', deviceId)
            commit('setFiscalization', { deviceId, fiscalization: false })
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    turnFiscalizationOn ({ commit }, { childCompanyId, businessUnitId, deviceId, deleteData }) {
      return new Promise((resolve, reject) => {
        clientsDevices.turnFiscalizationOn({ childCompanyId, businessUnitId, electronicDeviceId: deviceId, deleteData })
          .then(response => {
            commit('setFiscalization', { deviceId, fiscalization: true })
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    turnFiscalizationOff ({ commit }, { childCompanyId, businessUnitId, deviceId }) {
      return new Promise((resolve, reject) => {
        clientsDevices.turnFiscalizationOff({ childCompanyId, businessUnitId, electronicDeviceId: deviceId })
          .then(response => {
            commit('setFiscalization', { deviceId, fiscalization: false })
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    setHeader (context, { childCompanyId, businessUnitId, electronicDeviceId, header }) {
      if (header === '') {
        header = '{empty}'
      }
      return new Promise((resolve, reject) => {
        clientsDevices.setHeader({ childCompanyId, businessUnitId, electronicDeviceId, header })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getHeader (context, { childCompanyId, businessUnitId, electronicDeviceId }) {
      return new Promise((resolve, reject) => {
        clientsDevices.getHeader({ childCompanyId, businessUnitId, electronicDeviceId })
          .then(response => {
            const data = response.data.items[0]
            if (data.data === '{empty}') {
              data.data = ''
            }
            resolve(data)
          })
          .catch(error => reject(error))
      })
    },
    setFooter (context, { childCompanyId, businessUnitId, electronicDeviceId, footer }) {
      if (footer === '') {
        footer = '{empty}'
      }
      return new Promise((resolve, reject) => {
        clientsDevices.setFooter({ childCompanyId, businessUnitId, electronicDeviceId, footer })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getFooter (context, { childCompanyId, businessUnitId, electronicDeviceId }) {
      return new Promise((resolve, reject) => {
        clientsDevices.getFooter({ childCompanyId, businessUnitId, electronicDeviceId })
          .then(response => {
            const data = response.data.items[0]
            if (data.data === '{empty}') {
              data.data = ''
            }
            resolve(data)
          })
          .catch(error => reject(error))
      })
    },
    enable ({ commit }, { childCompanyId, businessUnitId, deviceId }) {
      return new Promise((resolve, reject) => {
        clientsDevices.enable({ childCompanyId, businessUnitId, electronicDeviceId: deviceId })
          .then(response => {
            commit('enableDevice', deviceId)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    disable ({ commit }, { childCompanyId, businessUnitId, deviceId }) {
      return new Promise((resolve, reject) => {
        clientsDevices.disable({ childCompanyId, businessUnitId, electronicDeviceId: deviceId })
          .then(response => {
            commit('disableDevice', deviceId)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  },

  mutations: {
    ...mutations,
    deregisterDevice (store, deviceId) {
      Vue.set(store.items[deviceId], 'activation_date', null)
    },
    enableDevice (store, deviceId) {
      Vue.set(store.items[deviceId], 'enabled', true)
    },
    disableDevice (store, deviceId) {
      Vue.set(store.items[deviceId], 'enabled', false)
    },
    setFiscalization (store, { deviceId, fiscalization }) {
      Vue.set(store.items[deviceId], 'fiscalization', fiscalization)
    }
  }
}
